import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button, Panel } from 'react-bootstrap';
import axios from '../../../../constants/axios.js';
import alert from 'alertify.js';
import selectOptionFormatter from './../../../../selectors/selectOptionFormatter';
import FormRenderField from './../../../FormTemplate/InputControl';
import Select from './../../../FormTemplate/Select';
import TextareaControl from './../../../FormTemplate/TextareaControl';

class FinalPaymentForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         paymentAccounts: []
      };
   }

   componentDidMount() {
      axios.get('inventoryPurchases/getPurchasePaymentAccounts')
         .then((res) => {
            this.setState({
               paymentAccounts: selectOptionFormatter(res.data)
            });
         });
   }

   submit = (inputs) => {
      inputs.invoice_id = this.props.invoiceId;
      return axios.post('inventoryPurchases/purchaseFullPayment', inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Saved');
               this.props.changeRoute('/purchase');
            } else {
               alert.error('Something Unexpected');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Ohh God. Sob Ses.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, invalid, error } = this.props;
      const { paymentAccounts } = this.state;
      return (
         <div>
            <Panel bsStyle="success" header="Full Payment Form" >
               <form noValidate autoComplete="off" onSubmit={handleSubmit(this.submit)} >
                  <Field name="discount" type="number" component={FormRenderField} label="Purchase Discount" />
                  <Field name="payment_chart_of_account_id" allowEmpty={true} options={paymentAccounts}
                         component={Select} label="Made Payment From Account" />

                  <Field name="memo" label="Memo" component={TextareaControl} />

                  {error && <strong className="input-validation-error" >{error}</strong>}
                  <Button type="submit" bsStyle="success" block
                          disabled={submitting || invalid} >Pay</Button>
               </form>
            </Panel>
         </div>
      );
   }
}

FinalPaymentForm.propTypes = {
   handleSubmit: PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.object,
   params: PropTypes.object,
   fullPaymentSubmit: PropTypes.func,
   invoiceId: PropTypes.string.isRequired,
   changeRoute: PropTypes.func.isRequired
};

export default reduxForm({
   form: 'fullPayment',
   initialValues: {
      payment_chart_of_account_id: 1300,
   }
})(FinalPaymentForm);



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchasePayment/FullPaymentForm.js
 **/